import { format } from './format';
import { suggest } from './suggest';
import { validate } from './validate';

// TODO - This need to be changed back to `export * as displayName ...`
// so it can be tree shakable.
export const displayName = {
    format,
    suggest,
    validate,
};
